import { render, staticRenderFns } from "./PublicIdeaPortalApp.vue?vue&type=template&id=3444d361&scoped=true"
import script from "./PublicIdeaPortalApp.vue?vue&type=script&lang=ts"
export * from "./PublicIdeaPortalApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444d361",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VApp,VMain,VSlideYTransition})
